import { Actions as CareerHistoryActions } from 'src/components/Profile/CareerHistory/actions';
import { Actions as EducationActions } from 'src/components/Profile/Education/actions';
import { Actions as LanguageActions } from 'src/components/Profile/Languages/actions';
import { Actions as LicenceActions } from 'src/components/Profile/Licences/actions';
import { Actions as NextRoleActions } from 'src/components/Profile/NextRole/reducer';
import { Actions as PersonalDetailsActions } from 'src/components/Profile/PersonalDetails/actions';
import { Actions as ProfileVisibilityActions } from 'src/components/Profile/ProfileVisibility/actions';
import { Actions as ResumeActions } from 'src/components/Profile/Resume/reducer';
import { Actions as SkillsActions } from 'src/components/Profile/Skills/actions';
import { Actions as SummaryActions } from 'src/components/Profile/Summary/actions';
import { classifyError } from 'src/modules/error-helper';
import type { ReduxInjections, ReduxState } from 'src/types';
import { GetSuggestionsDocument } from 'src/types/graphql';

import {
  updateSuggestionsSuccess,
  updateSuggestionsFailure,
} from './actionCreators';

const apiUpdates: string[] = [
  PersonalDetailsActions.PERSONAL_DETAILS_UPDATE_SUCCESS,
  SummaryActions.SUMMARY_UPDATE_SUCCESS,
  CareerHistoryActions.UPDATE_CAREER_HISTORY_SUCCESS,
  CareerHistoryActions.DELETE_CAREER_HISTORY_SUCCESS,
  SkillsActions.UPDATE_SKILLS_SUCCESS,
  ResumeActions.RESUME_UPLOAD_SUCCESS,
  ResumeActions.RESUME_DELETE_SUCCESS,
  ResumeActions.RESUME_UPDATE_DEFAULT_SUCCESS,
  ProfileVisibilityActions.PROFILE_VISIBILITY_UPDATE_SUCCESS,
  NextRoleActions.NEXT_ROLE_UPDATE_WORKTYPE_SUCCESS,
  NextRoleActions.NEXT_ROLE_UPDATE_AVAILABILITY_SUCCESS,
  NextRoleActions.NEXT_ROLE_UPDATE_CLASSIFICATION_SUCCESS,
  EducationActions.UPDATE_QUALIFICATION_SUCCESS,
  EducationActions.REMOVE_QUALIFICATION_SUCCESS,
  NextRoleActions.NEXT_ROLE_UPDATE_SALARY_SUCCESS,
  NextRoleActions.NEXT_ROLE_UPDATE_RTW_SUCCESS,
  LicenceActions.UPDATE_LICENCE_SUCCESS,
  LicenceActions.REMOVE_LICENCE_SUCCESS,
  LanguageActions.UPDATE_LANGUAGE_SUCCESS,
  LanguageActions.REMOVE_LANGUAGE_SUCCESS,
];

const shouldUpdateSuggestions = (type: string, getState: () => ReduxState) =>
  apiUpdates.includes(type) &&
  getState().profile?.isProfileSuggestionsExperiment;
export const makeSuggestionsUpdater = ({
  api: { queryGql },
  appConfig,
}: ReduxInjections) => ({
  on: shouldUpdateSuggestions,
  run: () => {
    const { language: languageCode, zone } = appConfig;
    return queryGql({
      query: GetSuggestionsDocument,
      variables: {
        zone,
        languageCode,
      },
      fetchPolicy: 'network-only',
    });
  },
  success: updateSuggestionsSuccess,
  failure: updateSuggestionsFailure,
  classifyError,
});
